import { Api } from '@/services/Api';

export default {
    /*  1. Get all data */
    getCompanies (keyword = '') {
        return Api().get(`/Company${keyword ? '?Keyword=' + keyword : ''}`);
    },

    /*  2. Get one column */
    getCompany (id) {
        return Api().get(`/Company/${id}`);
    },

    /*  3. Create one column */
    saveCompany (body) {
        return Api().post(`/Company`, body);
    },

    /*  4. Delete one or more column */
    deleteCompanies (companies) {
        return Api().post(`/Company/DeleteCompany`, companies);
    },

    /*  5. post one or more columns */
    postCompanies ( companies ) {
        return Api().post(`/Company/PostCompany`, companies);
    },
}